export const version = '1.2.10';
//# sourceMappingURL=version.js.map